import { TableViewData } from 'api/Types';
import Fetcher from 'middlewares/Fetcher';
import { ReduxState } from 'types/redux';
import {
  getBorrowerApplicationsSuccess,
  getBorrowerApplicationsFailure,
  GetBorrowerApplicationsAction,
} from './ActionCreator';
import { LoanOriginationSystemBorrowerDetailsActionType } from './ActionTypes';
import { BORROWER_APPLICATIONS_PER_PAGE_DEFAULT } from 'components/LoanOriginationSystem/BorrowerDetails/pagination';
import { SimplifiedApplication, SimplifiedApplicationsApi } from 'api/LoanOriginationSystem/SimplifiedApplicationsApi';

const GetBorrowerApplicationsMiddleware = (api: SimplifiedApplicationsApi) =>
  Fetcher<TableViewData<SimplifiedApplication>, GetBorrowerApplicationsAction, ReduxState>(
    LoanOriginationSystemBorrowerDetailsActionType.GetBorrowerApplications,
    getBorrowerApplicationsSuccess,
    getBorrowerApplicationsFailure,
    (action) => {
      const { id, sortingType } = action.payload;

      return api.getBorrowerApplications(
        id,
        {
          offset: 0,
          count: BORROWER_APPLICATIONS_PER_PAGE_DEFAULT,
        },
        sortingType,
      );
    },
  );

export default GetBorrowerApplicationsMiddleware;
